<drag-uploader
			   (upload)="uploadFiles($event)"
			   [label]="label"
			   [loadMessage]="initializingUpload ? ('file-upload.initializing-upload' | translate) : finalizingUpload ? ('file-upload.finalizing-upload' | translate) : busy ? ('file-upload.uploading' | translate) : undefined"
			   [disabled]="maxFiles != 0 && currentFiles >= maxFiles" accept="{{ accept }}"
			   [multiple]="maxFiles != 1" />
@for (file of uploadedFiles; track file) {
	<div [hidden]="hideUploadedFiles" class="uploaded-file"><span class="fa fa-times" (click)="removeFile(file)"></span>{{ file.name }}</div>
}
@for (file of uploading; track file) {
	<div class="uploaded-file" [class.in-progress]="file.status == 0" [class.error]="file.status == 2" animate.leave="fade-out">
		<div class="upload-progress" [style.width.%]="file.progress"></div>
		<div>{{ file.name }}</div>
	</div>
}
